import { fabric } from 'fabric';

const buildMagicFrameSelection = (magicFrame, canvas) => {
  const invisibleText = new fabric.Textbox('', {
    left: magicFrame.left,
    top: magicFrame.top,
    width: 0,
    height: 0,
  });

  return new fabric.ActiveSelection([magicFrame, invisibleText], {
    canvas,
  });
};

export const prepareVisualExportSelection = (
  activeObject,
  canvas = window.canvas
) => {
  if (!activeObject) {
    return {
      activeObject: undefined,
      selection: undefined,
    };
  }

  const normalizedActiveObject =
    activeObject._magicFrame?.type === 'MagicFrame'
      ? activeObject._magicFrame
      : activeObject;

  const selection =
    normalizedActiveObject.type === 'MagicFrame'
      ? buildMagicFrameSelection(normalizedActiveObject, canvas)
      : normalizedActiveObject;

  return {
    activeObject: normalizedActiveObject,
    selection,
  };
};
